// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__39Fq6","approved":"Status_approved__17wan","rejected":"Status_rejected__30S1E","expired":"Status_expired__212JA","label":"Status_label__1bxOz"};